/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import React, { useEffect } from "react";
import { WithPreview } from "@quintype/components";
import { object, shape, string } from "prop-types";
import { pageview } from "../../../utils/gtm";
import { Link } from "@quintype/components";
import {
  AuthorElement,
  HeroImageWithCaption,
  RenderArticleContent,
  RenderTag,
  StorySummary,
  RenderAuthorBio,
  RenderWhatsAppChannel,
} from "../../templates/StoryElements";
import SocialShare from "../../common/SocialShare";
import TwoComponentCol from "../../templates/TwoComponentCol";
import MultiColumn from "../../templates/MultiColumn";
import MagazineSideCol from "../../common/MagazineSideCol";
import AppealBox from "../../common/Appealbox";
import Ads from "../../ads/Ads";
import { adUnits } from "../../ads/ad-units";
import SubscribeBox from "../../templates/SubscribeBox";
import Comments from "./Comments";
import { v4 as uuidv4 } from "uuid";
import SettingPaywall from "./SettingPaywall";
import BookmarkIcon from "../../common/BookmarkIcon";
import { Helmet } from "react-helmet";
export function StoryPage(props) {
  const story = props.data.story;
  const data = props.data.homeData.collection.items;
  const sectionStories = props.data.homeData.sectionStories;
  let story_card = story.cards[0]["story-elements"][0];
  const topMultiColumnSections = ["Defence", "World", "Culture", "Politics", "Economy", "Infrastructure"];
  useEffect(() => {
    pageview();

    if (document.cookie.indexOf("readerID") === -1) {
      document.cookie = `readerID=${uuidv4()};path=/;max-age=31536000`;
    }
  }, []);

  return (
    <div className="container">
      <section className=" mx-auto mb-10 flex max-w-[1022px] justify-center gap-6 mobile:mb-1 tablet:flex-col tablet:items-center">
        <div className="max-w-[610px] tablet:w-[90%] tablet:mobile:w-[100%]">
          <div className="mb-4 flex flex-col gap-6">
            <div className="flex flex-col gap-[12px]">
              <Link href={`/section/${story?.sections[0].slug}`}>
                <p className="text-[20px] font-bold uppercase text-primary mobile:text-xs">{story?.sections[0].name}</p>
              </Link>
              <h1 className=" text-4xl font-bold leading-[130%] tracking-[-0px] mobile:text-[24px] mobile:font-[600] mobile:leading-[140%]">
                {story?.headline}
              </h1>
              <div className=" flex justify-between">
                <AuthorElement story={story} />
                <div className="flex items-center gap-3">
                  <BookmarkIcon story={story} />
                  <SocialShare url={story.url} headline={story?.headline} story={story} />
                </div>
              </div>
            </div>
            <HeroImageWithCaption story={story} />
          </div>
          {story_card?.type === "text" && story_card?.subtype === "summary" ? (
            <StorySummary summary={story_card.text} />
          ) : (
            <></>
          )}
          <SettingPaywall accessLevel={story.access} id={story.id} cards={story.cards} storyDetail={story}>
            <RenderArticleContent story={story} />
          </SettingPaywall>
          {story?.authors[0]?.bio && <RenderAuthorBio story={story} />}
          <RenderTag story={story} />
          <RenderWhatsAppChannel />

          <Comments
            url={story.url}
            // account_id={props.config?.["publisher-attributes"]?.metypeConfig?.metypeAccountId}
            account_id={4}
          />
          <br />

          <AppealBox />
        </div>

        <div className="flex flex-col max-w-[300px] tablet:w-[300px] tablet:mobile:w-[100%]">
          <div className="mt-5">
            <SubscribeBox />
          </div>

          <MagazineSideCol data={data} />

          <Ads adunit={adUnits["desktop-ap-rightatf-300x250"]} />
          {/* <ResponsiveRendering> */}
          <Ads adunit={adUnits["desktop-ap-right-300x600"]} />
          <></>
          {/* </ResponsiveRendering> */}
        </div>
      </section>
      <div className="  mx-auto mb-10 flex  justify-center gap-6 mobile:mb-1 tablet:flex-col tablet:items-center">
        <MultiColumn sections={topMultiColumnSections} sectionStories={sectionStories} />
      </div>
      <div className="  mx-auto mb-10 flex  justify-center gap-6 mobile:mb-1 tablet:flex-col tablet:items-center">
        <TwoComponentCol data={data} />
      </div>
    </div>
  );
}

StoryPage.propTypes = {
  data: shape({
    story: object,
    homeData: object,
    config: object,
  }),
  currentPath: string,
};

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story,
    relatedStories: Array(5).fill(story),
  })
);
